<template>
  <BasicModal
    :title="'パーツ作成'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container">
      <section>
        <template v-if="isEditStatus">
          <table class="table-box">
            <tr>
              <th class="table-box-header">
                メッセージ内容
              </th>
            </tr>
            <tr>
              <td>
                <b-input type="textarea"
                  v-model="tempScenario.mainmessage"
                  placeholder="例：お名前を入力してください">
                </b-input>
              </td>
            </tr>
          </table>
          <template v-if="recommends.length">
            <p style="font-weight: 600; margin: 8px;">文言の候補</p>
            <div
              v-for="(re, reIdx) in recommends"
              :key="reIdx" class="rec-button" style="padding: 8px;"
            >
              <span class="mdi mdi-circle-edit-outline -right-8px" style="cursor: pointer;" @click="tempScenario.mainmessage = re"></span>{{re}}
            </div>
          </template>
        </template>
        <b-message type="is-info" has-icon v-else>
          本パーツを追加後編集できます。<br>
          パーツの編集ボタンや、会話吹き出しをクリックして編集してください。
        </b-message>
      </section>
      <section v-if="isSelectStatus">
        <table class="table-box">
          <tr>
            <th class="table-box-header" style="max-width: 64px; width: 64px;">順番</th>
            <th class="table-box-header">選択肢内容</th>
            <th class="table-box-header" style="max-width: 80px; width: 80px;">削除</th>
          </tr>
          <tr v-for="(s, scnIDX) in tempScenario.select" :key="scnIDX">
            <td>
              <button class="button drag-button">
                <span class="mdi mdi-drag mdi-24px"></span>
              </button>
            </td>
            <td style="display: flex;">
              <!-- 選択肢内容 -->
              <textarea
                placeholder="選択肢を入力"
                v-model="s.message"
                class="input select-btn-message">
              </textarea>
            </td>
            <td>
              <!-- 削除ボタン -->
              <button class="button delete-button"
                @click="delSelect(scnIDX)"
                v-if="tempScenario.select.length > 1">
                <span class="mdi mdi-close"></span>
              </button>
            </td>
          </tr>
        </table>
      </section>
      <section v-if="tempScenario.select.length < 10 && isSelectStatus">
        <div>
          <button class="button is-fullwidth"
            @click="addSelect('')">
            <i class="mdi mdi-plus-box"></i>
            ボタン追加
          </button>
        </div>
      </section>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="createScenario(tempScenario, prevScenarioData, nextScenarioData)">作成する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import createUUID from '@/functions/createUUID'
import chatbot    from '@/api/chatbot'
export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    prevScenarioData: {
      type: Object,
    },
    nextScenarioData: {
      type: Object,
    },
    addScenario: {
      type: Object,
    },
  },
  data () {
    return {
      tempScenario: {
        name: '',
        robo_parts_set: '',
        mainmessage: '',
        beforenode: null,
        beforenodeX: 0,
        beforenodeY: 0,
        select: [],
        parameter: [],
        status: 0,
        template: '',
        quote_flg: true,
        image: '',
        image_ref: '',
        movie: '',
        movie_ref: '',
        start_flg: false,
        is_edit: true,
        is_cv: false,
        input_flg: false,
        output_flg: false,
      },
      select: {
        msg_type: '',
        message: '',
        text_option: '',
        next_node: '',
        point: '0',
      },
      ifSelect: {
        pointList: [{
          point: 0,
          terms: '',
          reset: false
        }],
        wordList: [{
          word: '',
          terms: '',
          parts: 0
        }],
        random: false
      },
      recommends: []
    }
  },
  created () {
    // 文言候補取得
    chatbot.getScenarioRecommend()
      .then((d) => {
        this.recommends = d.data
      })
    // 初期
    this.init()
    // 座標計算と初期設定
    this.calcAxisAndInitSetting()
    // 次のシナリオをセットする
    this.setNextNode()
  },
  computed: {
    isEditStatus () {
      return (
        this.tempScenario.status === 0 ||
        this.tempScenario.status === 2
      )
    },
    isSelectStatus () {
      return this.tempScenario.status === 0
    }
  },
  methods: {
    init () {
      // 選択肢付メッセージ
      if (this.addScenario.status === 1) {
        let addSelect = this.$_.cloneDeep(this.select)
        addSelect.msg_type = 'button'
        addSelect.text_option = 'white'
        this.tempScenario.select.push(this.$_.cloneDeep(addSelect))
        this.tempScenario.select.push(this.$_.cloneDeep(addSelect))
        this.tempScenario.status = 0
      // メッセージのみ
      } else if (this.addScenario.status === 2) {
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.status = 2
      // ロボ切替
      } else if (this.addScenario.status === 4) {
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.parameter = {}
        this.tempScenario.status = 3
      // 応募フォーム
      } else if (this.addScenario.status === 3) {
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.mainmessage = '[cv][/cv]'
        this.tempScenario.status = 1
        this.tempScenario['parameter'] = {
          disable_email: false,
          default_birth: new Date()
        }
      // 日程調整
      } else if (this.addScenario.status === 5) {
        this.tempScenario.status = 4
        this.tempScenario.mainmessage = '[calendar][/calendar]'
        this.tempScenario['parameter'] = {
          title: '',
          user_hash: [],
          user_hash_sub: [],
          user_hash_share: [],
          holiday_list: [],
          work_time_start: 9,
          work_time_end: 18,
          interval: 0,
          mtg_time: 1,
          count: 5,
          after: 1,
          period: 0,
          until: 30,
          is_AND: false,
          public_holiday: false,
          mtg_time_hour: 1,
          mtg_time_minute: 0,
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // 画像表示
      } else if (this.addScenario.status === 6) {
        this.tempScenario.status = 5
        this.tempScenario.mainmessage = '[image][/image]'
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // 自由入力
      } else if (this.addScenario.status === 7) {
        this.tempScenario.status = 6
        this.tempScenario.mainmessage = '[input]メッセージを記入して下さい[/input]'
        this.tempScenario['parameter'] = {
          colomn_name: '設定なし',
          custom_tag: '',
          default_birth: new Date(),
          apply_flg: false,
          any_flg: false
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // ファイルアップロード
      } else if (this.addScenario.status === 8) {
        this.tempScenario.status = 7
        this.tempScenario.mainmessage = '[fileupload][/fileupload]'
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario['parameter'] = {
          is_resume: false,
          to_google_drive: false
        }
      // 履歴書フォーム
      } else if (this.addScenario.status === 9) {
        this.tempScenario.status = 8
        this.tempScenario.mainmessage = '[resume][/resume]'
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario['parameter'] = {
          image_required: true,
          default_birth: new Date()
        }
      // Startに戻る
      } else if (this.addScenario.status === 10) {
        this.tempScenario.status = 9
        this.tempScenario.mainmessage = '[restart][/restart]'
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // メール送付
      } else if (this.addScenario.status === 11) {
        this.tempScenario.status = 10
        this.tempScenario.mainmessage = 'メール内容を入力'
        this.tempScenario['parameter'] = {
          title: '',
          to: '',
          cc: '',
          after: 0
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // 条件で分ける
      } else if (this.addScenario.status === 12) {
        this.tempScenario.status = 12
        this.tempScenario.mainmessage = '条件で分岐させる'
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.parameter.push(this.$_.cloneDeep(this.ifSelect))
        this.tempScenario.parameter.push(this.$_.cloneDeep(this.ifSelect))
      // チェック項目
      } else if (this.addScenario.status === 13) {
        this.tempScenario.status = 13
        this.tempScenario.mainmessage = '[checkbox][/checkbox]'
        this.tempScenario.parameter.push({item_message: ''})
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // 動画
      } else if (this.addScenario.status === 14) {
        this.tempScenario.mainmessage = '[movie][/movie]'
        this.tempScenario['parameter'] = {
          url: '',
          use: 'youtube',
          filename: ''
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.status = 14
      // プルダウン選択
      } else if (this.addScenario.status === 15) {
        this.tempScenario.mainmessage = '[pulldown]プルダウンから選択してください[/pulldown]'
        this.tempScenario.parameter.push({
          pullDownId      : createUUID(),
          isRequired      : false,
          refPullDownId   : 'None',
          refItemId       : '',
          isLinking       : false,
          title           : '',
          isDispNextTitle : true,
          items           : [{itemId   : createUUID(), itemName : ''}]
        })
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.status = 15
      // SMS送付
      } else if (this.addScenario.status === 16) {
        this.tempScenario.mainmessage = '送付内容を入力'
        this.tempScenario['parameter'] = {
          to: '',
          after: 0
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.status = 16
      // カルーセル
      } else if (this.addScenario.status === 17) {
        this.tempScenario.mainmessage = '[carousel][/carousel]'
        this.tempScenario['parameter'] = {
          select1: {id: 1, title: "", contents: "", image_ref: {image_data:"", name:""}, button: ""},
          select2: {id: 2, title: "", contents: "", image_ref: {image_data:"", name:""}, button: ""}
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
        this.tempScenario.status = 17
      // ファイルダウンロード
      } else if (this.addScenario.status === 18) {
        this.tempScenario.mainmessage = '[filedownload]以下からダウンロードしてください。[/filedownload]'
        this.tempScenario.status = 18
        this.tempScenario['parameter'] = {
          filename: [],
          filepaths: [],
          tempfilepath: ''
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // 回答出力
      } else if (this.addScenario.status === 19) {
        this.tempScenario.mainmessage = '[output][/output]'
        this.tempScenario.status = 19
        this.tempScenario['parameter'] = {
          format          : 'csv',
          output          : 'mail',
          mail_to         : '',
          user_uuid       : null,
          preserve        : false,
          drive_info      : {
            id        : '',
            name      : '',
            mime_type : '',
            folderPath: []
          },
          file_name       : ''
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      // 検索
      } else if (this.addScenario.status === 20) {
        this.tempScenario.mainmessage = '[search][/search]'
        this.tempScenario.status = 20
        this.tempScenario['parameter'] = {
          search: [
            {
              keywords   : '',
              type       : 0,
              title      : '',
              description: '',
              url        : '',
              renkeiID   : '',
              image_ref: {
                image_data: '',
                image_id: '',
                name: ''
              },
            }
          ],
          message: '',
          disable_email: false
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      } else if (this.addScenario.status === 21) {
        // PDFダウンロード
        this.tempScenario.mainmessage = '[pdf-download][/pdf-download]'
        this.tempScenario.status = 21
        this.tempScenario['parameter'] = {
          item_list           : '',
          format_no           : 0,
          file_name           : '',
          send_to             : '',
          attachment_file_name: ''
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      } else if (this.addScenario.status === 100) {
        // パーツセット
        this.tempScenario.mainmessage = '[parts-set][/parts-set]'
        this.tempScenario.status = 100
        this.tempScenario['parameter'] = {
          robo_parts_set_name: '',
        }
        this.tempScenario.select.push(this.$_.cloneDeep(this.select))
      }
    },
    cancel () {
      this.$emit('cancel', false, null, null)
    },
    calcAxisAndInitSetting () {
      if (this.prevScenarioData) {
        // 前座標ある場合
        this.tempScenario.beforenodeX = this.prevScenarioData.beforenodeX + 100
        this.tempScenario.beforenodeY = this.prevScenarioData.beforenodeY + 100
        this.start_flg = false
      } else {
        // 最初の場合
        this.tempScenario.beforenodeX = 20
        this.tempScenario.beforenodeY = 20
        this.start_flg = true
      }
      this.tempScenario.beforenode = createUUID()
    },
    setNextNode () {
      if (this.nextScenarioData) {
        // 次のシナリオある場合
        this.tempScenario.select[0].next_node = this.nextScenarioData.beforenode
      }
    },
    addSelect (v) {
      const s = {
        'message': '',
        'msg_type': 'button',
        'text_option': 'white',
        'point': '0',
        'next_node': ''
      }
      this.tempScenario.select.push(s)
    },
    createScenario (data, prev, next) {
      this.$emit('create-scenario', data, prev, next)
      this.cancel()
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 8px;
  max-height: 500px;
  overflow: auto;
  section {
    text-align: left;
  }
  section:not(:first-child) {
    margin-top: 24px;
  }
  .table-box {
    width: 100%;
    button, input, select {
      width: 100%;
      background: transparent !important;
    }
    .drag-button {
      border: solid thin #ccc !important;
    }
    .select-box {
      width: max-content;
      display: contents;
    }
  }
  .table-box-header {
    border: solid thin #ccc !important;
    background: rgb(250, 230, 230) !important;
    color: #222;
    padding: 8px !important;
    text-align: center;
  }
  .message-content {
    margin-top: 8px;
  }
  .point-input {
    width: 80px;
  }
  .delete-button {
    background: #f8f8f8;
  }
  /* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance:textfield;
  }
  input::-ms-clear {
    visibility:hidden
  }
  .select-btn-message {
    resize: none;
    padding-top: 8px;
    padding-left: 8px;
    border-radius: 4px;
    border-color: #ccc;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.file-name-container {
  display: flex;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalCreateScenario.vue